import React, { lazy } from 'react';
import { ChartPieIcon, UsersIcon, CurrencyDollarIcon, MapPinIcon, TruckIcon, ArrowsRightLeftIcon, BuildingStorefrontIcon, CogIcon, FingerPrintIcon, Bars4Icon, DevicePhoneMobileIcon, ArrowPathIcon, LanguageIcon, ArrowRightOnRectangleIcon, TicketIcon } from '@heroicons/react/24/outline';

const Profile = lazy(() => import('./profile'));
const Dashboard = lazy(() => import('./dashboard/support'));
const RegionalAgency = lazy(() => import('./dashboard/transportAgencyDashboard'));
const Payments = lazy(() => import('./payments'));
const Reservations = lazy(() => import('./reservations'));
const ManageAssociations = lazy(() => import('./manage-associations'));
const ManageUser = lazy(() => import('./manage-user'));
const ManageRoles = lazy(() => import('./manage-roles'));
const Vehicle = lazy(() => import('./vehicle'));
const ManageStations = lazy(() => import('./manage-stations'));
const ManageRoute = lazy(() => import('./manage-routes'));
const ManageAppSyncRecords = lazy(() => import('./manage-app-sync'));
const ManageAppFile = lazy(() => import('./manage-app-file'));
const Locations = lazy(() => import('./locations'));
const Fleet = lazy(() => import('./fleet'));
const ManageAgents = lazy(() => import('./manage-agents'));
const StationDashboard = lazy(() => import('./dashboard/stationDashboard'));
const StationDetail = lazy(() => import('./manage-stations/stationDetails'));
const TransportMinister = lazy(() => import('./dashboard/transportMinsterDashboard'));
const AssociationManagerDashboard = lazy(() => import('./dashboard/associationManagerDashboard'));
const AgentDashboard = lazy(() => import('./dashboard/agentDashboard'));
const VehicleReport = lazy(() => import('./vehicleReport'));
const VehicleEntries = lazy(() => import('./vehicleEntries'));
const ManageLanguage = lazy(() => import('./manage-language'))
const ExitTickets = lazy(() => import('./terminal-exit/exitTickets'));
const ReceiptPurpose = lazy(() => import('./terminal-exit/receiptPurpose'));
const FinanceDashbaord = lazy(() => import('./dashboard/financeDashbaord'));
const FinancePage = lazy(() => import('./finance'));

const DefaultViews = {
    "/profile": {
        "label": "profile_settings",
        "component": <Profile />,
        "icon": CogIcon,
    }
};


const RoleBasedViews = {
    "12d93a4c-207e-436c-b99f-385cf401e9b3": {
        "name": "passenger",
        "routes": {
        },
    },
    "332952a2-f946-4bde-b704-aee10806e934": {
        "name": "driver",
        "routes": {
        },
    },
    "a730f1fe-1f68-4120-9e4e-791651e278ab": {
        "name": "transport_minister_manager",
        "routes": {
            "/ministry": {
                "label": "Ministry Dashboard",
                "component": <TransportMinister />,
                "icon": ChartPieIcon,
            },
            "/VehicleReport": {
                "label": "Vehicle Report",
                "component": (<VehicleReport />),
                "icon": ChartPieIcon,
            },
            "/manage-associations": {
                "label": "associations",
                "component": <ManageAssociations action_policies={[]} />,
                "icon": UsersIcon,

            },
            "/locations": {
                "label": "locations",
                "component": <Locations action_policies={[]} />,
                "icon": MapPinIcon,
            },
            "/manage-stations": {
                "label": "stations",
                "component": <ManageStations action_policies={[]} />,
                "icon": BuildingStorefrontIcon,
            },
            "/vehicle": {
                "label": "vehicles",
                "component": <Vehicle action_policies={[]} />,
                "icon": TruckIcon,
            },
            "/fleet": {
                "label": "fleets",
                "component": <Fleet action_policies={[]} />,
                "icon": TruckIcon,
            },
            "/manage-routes": {
                "label": "routes",
                "component": <ManageRoute action_policies={[]} />,
                "icon": ArrowsRightLeftIcon,
            },
        },
    },
    "3d82266a-9ddf-49ac-9e38-a97ea473ad7f": {
        "name": "minister_of_transport",
        "routes": {
            "/ministry": {
                "label": "Ministry Dashboard",
                "component": <TransportMinister />,
                "icon": ChartPieIcon,
            },
        },
    },
    "2b33fc0a-3374-4bf5-908d-a6939deaa23f": {
        "name": "station_fleet_manager",
        "routes": {
            "/": {
                "label": "Vehicle Entries",
                "component": <VehicleEntries action_policies={['add']} />,
                "icon": TruckIcon,
            },
        },
    },
    "c2c8922c-23a1-49c5-9a3a-04412042e78c": {
        "name": "regional",
        "routes": {
        },
    },
    "886a010b-9200-4e98-8d2e-540a84442f50": {
        "name": "association",
        "routes": {
            "/": {
                "label": "dashboard",
                "component": (<AssociationManagerDashboard />),
                "icon": ChartPieIcon,
            },
            // "/manage-associations": {
            //     "label": "associations",
            //     "component": <ManageAssociations action_policies={['edit']} />,
            //     "icon": UsersIcon,

            // },
            "/vehicle": {
                "label": "vehicles",
                "component": <Vehicle action_policies={['add', 'edit']} />,
                "icon": TruckIcon,
            },
            "/fleet": {
                "label": "fleets",
                "component": <Fleet action_policies={['add', 'edit']} />,
                "icon": TruckIcon,
            },
        },
    },
    "5bded346-154b-49ff-985e-b03885e69197": {
        "name": "transport_agency_manager",
        "routes": {
            "/": {
                "label": "dashboard",
                "component": (<RegionalAgency />),
                "icon": ChartPieIcon,
            },
            "/manage-associations": {
                "label": "associations",
                "component": <ManageAssociations action_policies={['add', 'edit']} />,
                "icon": UsersIcon,
            },
            "/manage-stations": {
                "label": "stations",
                "component": <ManageStations action_policies={['add', 'edit']} />,
                "icon": BuildingStorefrontIcon,
            },
            "/VehicleReport": {
                "label": "Vehicle Report",
                "component": (<VehicleReport />),
                "icon": ChartPieIcon,
            },
        },
    },
    "795717d5-a27f-471c-b20c-a4ef7cfbb1ec": {
        "name": "cheche_support",
        "routes": {
            "/": {
                "label": "dashboard",
                "component": (<Dashboard />),
                "icon": ChartPieIcon,
            },
            "/terminal-exit": {
                "label": "Terminal Exit",
                "icon": TicketIcon,
                "children": [
                    {
                        "path": "/terminal-exit/tickets",
                        "label": "Exit Tickets",
                        "component": <ExitTickets action_policies={['add', 'edit']} />,
                        "icon": ArrowRightOnRectangleIcon
                    },
                    {
                        "path": "/terminal-exit/receipts",
                        "label": "Receipt Purpose",
                        "component": <ReceiptPurpose action_policies={['add', 'edit']} />,
                        "icon": ArrowRightOnRectangleIcon
                    }
                ],
                "component": null
            },
            "/VehicleReport": {
                "label": "Vehicle Report",
                "component": (<VehicleReport />),
                "icon": ChartPieIcon,
            },
            "/manage-associations": {
                "label": "associations",
                "component": <ManageAssociations action_policies={['add', 'edit']} />,
                "icon": UsersIcon,

            },
            "/manage-stations": {
                "label": "stations",
                "component": <ManageStations action_policies={['add', 'edit']} />,
                "icon": BuildingStorefrontIcon,
            },
            "/manage-users": {
                "label": "users",
                "component": <ManageUser action_policies={['add', 'edit']} />,
                "icon": UsersIcon,
            },
            "/manage-roles": {
                "label": "roles",
                "component": <ManageRoles action_policies={['add', 'edit']} />,
                "icon": FingerPrintIcon,
            },
            "/payments": {
                "label": "payments",
                "component": <Payments />,
                "icon": UsersIcon,
            },
            "/reservations": {
                "label": "Reservations",
                "component": <Reservations />,
                "icon": CurrencyDollarIcon,
            },
            "/locations": {
                "label": "locations",
                "component": <Locations action_policies={['add', 'edit']} />,
                "icon": MapPinIcon,

            },
            "/manage-agents": {
                "label": "agents",
                "component": <ManageAgents action_policies={['add', 'edit']} />,
                "icon": UsersIcon,
            },
            "/vehicle": {
                "label": "vehicles",
                "component": <Vehicle action_policies={['add', 'edit']} />,
                "icon": TruckIcon,
            },
            "/fleet": {
                "label": "fleets",
                "component": <Fleet action_policies={['add', 'edit']} />,
                "icon": TruckIcon,
            },
            "/manage-routes": {
                "label": "routes",
                "component": <ManageRoute action_policies={['add', 'edit']} />,
                "icon": ArrowsRightLeftIcon,
            },
            "/manage-app-sync": {
                "label": "app_sync_record",
                "component": <ManageAppSyncRecords />,
                "icon": ArrowPathIcon,
            },
            "/manage-app-file": {
                "label": "mobile_application",
                "component": <ManageAppFile action_policies={['upload', 'download']} />,
                "icon": DevicePhoneMobileIcon,
            },
            "/manage-language": {
                "label": "manage_language",
                "component": <ManageLanguage action_policies={['add', 'edit', 'delete']} />,
                "icon": LanguageIcon,
            },
            "/finance-page": {
                "label": "Manage Finance",
                "component": <FinancePage />,
                "icon": CurrencyDollarIcon,
            },
        },
    },
    "3b44fc0a-3374-4bf5-908d-a6939deaa37f": {
        "name": "station_agent",
        "routes": {
            "/": {
                "label": "menu_agent_dashboard",
                "component": <AgentDashboard />,
                "icon": ChartPieIcon,
            }
        },
    },
    "a4288f73-64cc-44de-b889-7a777041a26e": {
        "name": "station_manager",
        "routes": {
            "/": {
                "label": "menu_station_dashboard",
                "component": <StationDashboard />,
                "icon": ChartPieIcon,
            },

            "/fleet": {
                "label": "fleets",
                "component": <Fleet action_policies={[]} />,
                "icon": TruckIcon,
            },
            "/vehicle": {
                "label": "vehicles",
                "component": <Vehicle action_policies={[]} />,
                "icon": TruckIcon,
            },
            "/manage-routes": {
                "label": "routes",
                "component": <ManageRoute action_policies={[]} />,
                "icon": ArrowsRightLeftIcon,
            },
            "/manage-agents": {
                "label": "stations",
                "component": <StationDetail action_policies={[]} />,
                "icon": BuildingStorefrontIcon,
            },
            "/manage-associations": {
                "label": "associations",
                "component": <ManageAssociations action_policies={[]} />,
                "icon": UsersIcon,

            },
        },
    },
    "c2076e2d-4f2e-48b3-b1e3-2cc46374049e": {
        "name": "station_supervisior",
        "routes": {
            "/": {
                "label": "menu_station_dashboard",
                "component": <StationDashboard />,
                "icon": ChartPieIcon,
            },
            "/fleet": {
                "label": "fleets",
                "component": <Fleet action_policies={['add', 'edit']} />,
                "icon": TruckIcon,
            },
            "/vehicle": {
                "label": "vehicles",
                "component": <Vehicle action_policies={['add', 'edit']} />,
                "icon": TruckIcon,
            },
            "/manage-routes": {
                "label": "routes",
                "component": <ManageRoute action_policies={['add', 'edit']} />,
                "icon": ArrowsRightLeftIcon,
            },
            "/manage-agents": {
                "label": "stations",
                "component": <StationDetail action_policies={['add', 'edit']} />,
                "icon": BuildingStorefrontIcon,
            },
            "/manage-associations": {
                "label": "associations",
                "component": <ManageAssociations action_policies={['add', 'edit']} />,
                "icon": UsersIcon,

            },
        },
    },
    "3ff4207c-e431-4767-a3a5-58746ea82d07": {
        "name": "cheche_manager",
        "routes": {
            "/": {
                "label": "dashboard",
                "component": (<Dashboard />),
                "icon": ChartPieIcon,
            },
            "/manage-associations": {
                "label": "associations",
                "component": <ManageAssociations action_policies={['add', 'edit']} />,
                "icon": UsersIcon,

            },
            "/manage-users": {
                "label": "users",
                "component": <ManageUser action_policies={['add', 'edit']} />,
                "icon": UsersIcon,
            },
            "/locations": {
                "label": "locations",
                "component": <Locations action_policies={['add', 'edit']} />,
                "icon": MapPinIcon,
            },
            "/manage-stations": {
                "label": "stations",
                "component": <ManageStations action_policies={['add', 'edit']} />,
                "icon": BuildingStorefrontIcon,
            },
            "/vehicle": {
                "label": "vehicles",
                "component": <Vehicle action_policies={['add', 'edit']} />,
                "icon": TruckIcon,
            },
            "/fleet": {
                "label": "fleets",
                "component": <Fleet action_policies={['add', 'edit']} />,
                "icon": TruckIcon,
            },
            "/manage-routes": {
                "label": "routes",
                "component": <ManageRoute action_policies={['add', 'edit']} />,
                "icon": ArrowsRightLeftIcon,
            },
            "/finance-page": {
                "label": "Manage Finance",
                "component": <FinancePage />,
                "icon": CurrencyDollarIcon,
            },
        },
    },
    "4d465dc6-05e2-4b5d-ad9b-b1d1b14cef48": {
        "name": "vehicle_entries",
        "routes": {
            "/vehicle": {
                "label": "vehicles",
                "component": <Vehicle action_policies={['add', 'edit']} />,
                "icon": TruckIcon,
            },
        }
    },
    "13ff6a36-d631-4fe3-881c-2d6616d9c72d": {
        "name": "cheche_finance",
        "routes": {
            "/": {
                "label": "dashboard",
                "component": (<FinanceDashbaord />),
                "icon": ChartPieIcon,
            },
            "/finance-page": {
                "label": "Manage Finance",
                "component": <FinancePage />,
                "icon": CurrencyDollarIcon,
            },
        }
    }
};

export { DefaultViews, RoleBasedViews };
